import {UserModel} from '../models/user.model';
import {environment} from '../environments/environment';

export class StorageManager {
    private static readonly USER_TAG: string = environment.appName + '_' + 'user_tag' + '_' + environment.v;
    private static readonly CLIENT_TAG: string = environment.appName + '_' + 'client_tag' + '_' + environment.v;
    private static readonly VERSION_INFO_TAG: string = environment.appName + '_' + 'info_version_tag' + '_' + environment.v;
    private static readonly IS_INSTALL_TAG: string = environment.appName + '_' + 'IS_INSTALL_TAG' + '_' + environment.v;

    public static saveUser(user: UserModel) {
        localStorage.setItem(this.USER_TAG, JSON.stringify(user));
    }

    public static getUser(): UserModel {
       
        return JSON.parse(localStorage.getItem(this.USER_TAG));
    }
    public static getUserName() {
        console.log("this user tag",environment.v);
        return localStorage.getItem(environment.appName);
    }

    public static deleteUser() {
        localStorage.setItem(this.USER_TAG, null);
    }

    public static saveClient(client: any) {
        sessionStorage.setItem(this.CLIENT_TAG, JSON.stringify(client));
    }

    public static deleteClient() {
        sessionStorage.setItem(this.CLIENT_TAG, null);
    }

    public static getClient() {
        return JSON.parse(sessionStorage.getItem(this.CLIENT_TAG));
    }

    public static getVersionInfo() {
        return JSON.parse(localStorage.getItem(this.VERSION_INFO_TAG) || '{"version": 0}');
    }

    public static deleteVersionInfo() {
        localStorage.setItem(this.VERSION_INFO_TAG, null);
    }

    public static setVersionInfo(data) {
        localStorage.setItem(this.VERSION_INFO_TAG, JSON.stringify(data));
    }

}
